import { render } from "./CookieNotice.vue?vue&type=template&id=6a9e1d96&scoped=true"
import script from "./CookieNotice.vue?vue&type=script&lang=js"
export * from "./CookieNotice.vue?vue&type=script&lang=js"

import "./CookieNotice.vue?vue&type=style&index=0&id=6a9e1d96&lang=scss&scoped=true"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9e1d96"]])

export default __exports__